/**
 * @desc 删除首页横幅
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DeleteBannerParameter = {
  id?: string
}

const method = 'DELETE'
const url = '/content/operation/banner'

export const deleteBannerApi = (
  params?: DeleteBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

deleteBannerApi.method = method
deleteBannerApi.url = url
